import Input from "../../../../ui-components/Input";
import React from "react";
import {SimpleDiscountEditorProps} from "./types";

export const SimpleDiscountEditor = ({
  title,
  value,
  onChange,
  name,
  um,
  editable,
  ...rest
}: SimpleDiscountEditorProps) => {
  return <>
    <p className="font-semibold">
      {title}
    </p>
    <div className="flex items-center gap-3">
      {/* @ts-ignore */}
      <Input
        type="number"
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(parseFloat(e.target.value))}
        name={name}
        showErrorDialog={false}
        disabled={!editable}
        {...rest}
      />
      <span>{um}</span>
    </div>
  </>
}